import React, { useState, useEffect } from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'

const CompanyRadioItem = (props) => (<Radio inputProps={{ 'data-testid': 'company-select-radio-item' }} {...props} />)

// Expects a handleChange function to be passed with props
export const RadioList = (props) => {
  const { companyList, selectedCompany, setSelectedCompany } = props
  const [value, setValue] = useState('')

  const handleChange = (event) => {
    setSelectedCompany(companyList.find((company) => company.value === event.target.value))
    setValue(event.target.value)
  }

  useEffect(() => {
    let subscribed = true
    if (subscribed && selectedCompany) {
      setValue(selectedCompany.value)
    }
    // eslint-disable-next-line no-return-assign
    return () => (subscribed = false)
  }, [selectedCompany])

  return (
    <RadioGroup
      data-testid="company-select-radio"
      aria-label="company"
      name="company"
      value={`${value}`}
      onChange={handleChange}
    >
      {companyList
        .map((company) => (
          <FormControlLabel
            key={`radio-company-id-${company.value}`}
            control={(
              <CompanyRadioItem {...{
                value: `${company.value}`,
              }}
              />
            )}
            label={company.label}
            value={`${company.value}`}
          />
        ))}
    </RadioGroup>
  )
}
